$(document).ready(function () {
    $("#testdrive_modal .button-check-all").on("click", function () {

        $('#testdriveAgreeEmail').prop("checked", true);
        $('#testdriveAgreePhone').prop("checked", true);
        $('#testdriveAgreeRegulations1').prop("checked", true);
        $('#testdriveAgreeRegulations2').prop("checked", true);
    });

    $("#testdrive_modal").submit(function (e) {

        e.preventDefault();
        if (e.originalEvent.submitter.id === "choose_manual") {
            setInterval(updateDealers, 200);
            $(".inputProvinceWrapper").css('display', 'block');
            $("#choose_manual").remove();
            chooseManual = true;
            return;
        }

        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').empty();

        var firstname = $('#testdriveFirstname').val();
        var errors = 0;
        $('.testdriveFirstname .invalid-feedback').empty();
        if (!firstname) {
            $('#testdriveFirstname').addClass('is-invalid');
            $('.testdriveFirstname').siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
        } else {
            if (firstname.length < 3) {
                $('#testdriveFirstname').addClass('is-invalid');
                var errors = 1;
                $('.testdriveFirstname').siblings('invalid-feedback').prevObject.html('<p>Imię musi zawierać minimum trzy litery.</p>');
            } else {
                $('#testdriveFirstname').removeClass('is-invalid');
            }


        }

        var lastname = $('#testdriveLastname').val();
        $('.testdriveLastname .invalid-feedback').empty();
        if (!lastname) {
            $('#testdriveLastname').addClass('is-invalid');
            var errors = 1;
            $('.testdriveLastname').siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
        } else {
            if (lastname.length < 3) {
                $('#testdriveLastname').addClass('is-invalid');
                var errors = 1;
                $('.testdriveLastname').siblings('invalid-feedback').prevObject.html('<p>Nazwisko musi zawierać minimum trzy litery.</p>');
            } else {
                $('#testdriveLastname').removeClass('is-invalid');
            }
        }


        var email = $('#testdriveEmail').val();
        if (!email) {
            $('#testdriveEmail').addClass('is-invalid');
            $('.testdriveEmail').siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            var errors = 1;
        } else {
            if (IsEmail(email)) {
                $('#testdriveEmail').removeClass('is-invalid');
            } else {
                $('#testdriveEmail').addClass('is-invalid');
                $('.testdriveEmail').siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny adres e-mail</p>');
                var errors = 1;
            }
        }

        var phoneInput = $('#testdrivePhone');


        var phone = phoneInput.val();
        if (!phone) {
            $('#testdrivePhone').addClass('is-invalid');
            $('.testdrivePhone').siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            var errors = 1;
        } else {
            if (phone.length < 7) {
                $('#testdrivePhone').addClass('is-invalid');
                $('.testdrivePhone').siblings('invalid-feedback').prevObject.html('<p>Podany numer telefonu jest za krótki</p>');
                var errors = 1;
            } else {
                if (!validatePhone(phone)) {
                    $('#testdrivePhone').addClass('is-invalid');
                    $('.testdrivePhone').siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>');
                    var errors = 1;
                } else {
                    $('#testdrivePhone').removeClass('is-invalid');
                }
            }
        }

        let modelCounter = 0;
        var selectedModel = $("#inputModel").val();
        console.log(selectedModel)
        if (selectedModel === null && modelCounter++ < 1) {
            $('#inputModel').addClass('is-invalid');
            $('.inputModel').html('<p>Proszę wybrać model</p>').show();
            var errors = 1;
        } else {
            $('#inputModel').removeClass('is-invalid');
        }


        var selectedDealer = $("#inputDealerTestDrive").val();
        if (selectedDealer === null) {
            $('#inputDealerTestDrive').addClass('is-invalid');
            $('.inputDealer').html('<p>Proszę wybrać dealera</p>').show();
            var errors = 1;
        } else {
            $('#inputDealerTestDrive').removeClass('is-invalid');
        }

        var model = $('#inputModel').val();
        var agree1 = $('#testdriveAgreeEmail').prop('checked');
        var agree2 = $('#testdriveAgreePhone').prop('checked');
        var agree3 = $('#testdriveAgreeRegulations1').prop('checked');
        var agree4 = $('#testdriveAgreeRegulations2').prop('checked');
        var agreeVal1 = 0;
        var agreeVal2 = 0;
        var agreeVal3 = 0;
        var agreeVal4 = 0;
        if (agree1) {
            agreeVal1 = 1;
        }
        if (agree2) {
            agreeVal2 = 1;
        }
        if (agree3) {
            agreeVal3 = 1;
        }
        if (agree4) {
            agreeVal4 = 1;
        }

        /*if (!agree1 && !agree2 && !agree3) {
            var errors = 1;
            $('.form-check-input#testdriveAgreeEmail').addClass('is-invalid');
            $('.walid_register_agree_email').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            $('.form-check-input#testdriveAgreePhone').addClass('is-invalid');
            $('.walid_register_agree_phone').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            $('.form-check-input#formContactAgreeRegulations1').addClass('is-invalid');
            $('.walid_register_agree_phone').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
        }


        if (!email && !phone) {
            var errors = 1;
            $('#testdriveEmail').addClass('is-invalid');
            $('.walid_register_email .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
            $('#testdrivePhone').addClass('is-invalid');
            $('.walid_register_phone .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
        }*/

        var message = $('#testdriveQuestion').val();
        var emailCheckbox = $('#testdriveEmail');
        var agree1 = $('#testdriveAgreeEmail');

        if (agree1.is(':checked')) {
            if (emailCheckbox.val() === '') {
                var errors = 1;
                $('.walid_register_email').html('<p> Nie podałes E-maila </p>').show();
            }
        }

        var phoneCheckbox = $('#testdrivePhone');
        var agree2 = $('#testdriveAgreePhone');

        if (agree2.is(':checked')) {
            if (phoneCheckbox.val() === '') {
                var errors = 1;
                $('.walid_register_phone').html('<p> Nie podałes numeru telefonu </p>').show();
            }
        }

        var agree3 = $('#formContactAgreeRegulations1');

        if (agree3.is(':checked')) {
            if (phoneCheckbox.val() === '') {
                var errors = 1;
                $('.walid_register_phone').html('<p> Nie podałes numeru telefonu </p>').show();
            }
        }

        // var agree = $('#formContactAgreeEmail').prop('checked');
        // if (!agree) {
        //     $('.form-check-input#formContactAgreeEmail').addClass('is-invalid');
        //     $('.invalid-feedback-agree-email').html('<p>To pole jest wymagane</p>').show();
        //     var errors = 1;
        // } else {
        //     $('.form-check-input#formContactAgreeEmail').removeClass('is-invalid');
        //     $('.invalid-feedback-agree-email').empty().hide();
        //     agree = 1;
        // }

        // var agree2 = $('#formContactAgreePhone').prop('checked');
        // if (!agree2) {
        //     $('.form-check-input#formContactAgreeEmail').addClass('is-invalid');
        //     $('.invalid-feedback-agree-regulations2').html('<p>To pole jest wymagane</p>').show();
        //     var errors = 1;
        // } else {
        //     $('.form-check-input#formContactAgreeEmail').removeClass('is-invalid');
        //     $('.invalid-feedback-agree-regulations2').empty().hide();
        //     agree2 = 1;
        // }

        var agree3 = $('#testdriveAgreeRegulations1').prop('checked');
        /*if (!agree3) {
            $('#testdriveAgreeRegulations1').addClass('is-invalid');
            $('.invalid-feedback-agree-regulations1').html('<p>To pole jest wymagane</p>').show();
            var errors = 1;
        } else {
            $('#testdriveAgreeRegulations1').removeClass('is-invalid');
            $('.invalid-feedback-agree-regulations1').empty().hide();
            agree3 = 1;
        }*/

        if (!agree1.prop('checked') && !agree2.prop('checked') && !agree3) {
            errors = 1;
            $('#testdriveAgreeEmail').addClass('is-invalid');
            $('.testdriveAgreeEmail').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            $('#testdriveAgreePhone').addClass('is-invalid');
            $('.testdriveAgreePhone').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            $('#testdriveAgreeRegulations1').addClass('is-invalid');
            $('.testdriveAgreeRegulations1').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
        }

        var agree4 = $('#testdriveAgreeRegulations2').prop('checked');
        if (!agree4) {
            $('#testdriveAgreeRegulations2').addClass('is-invalid');
            $('.testdriveAgreeRegulations2').html('<p>To pole jest wymagane</p>').show();
            var errors = 1;
        } else {
            $('#testdriveAgreeRegulations2').removeClass('is-invalid');
            $('.testdriveAgreeRegulations2').empty().hide();
            agree4 = 1;
        }

        var utm_source = getCookie("utmSource");
        var utm_medium = getCookie("utmMedium");
        var utm_campaign = getCookie("utmCampaign");
        var gad_source = getCookie("gadSource");
        var gclid = getCookie("gclid");

        console.log(errors);
        if (errors == 0) {
            $('#testdrive_contact .btn-form').attr("disabled", "true");

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'formSubmit',
                form_id: 'test_drive_form',
                firstname: firstname,
                lastname: lastname,
                email: email,
                phone: phone,
                model_id: selectedModel,
                branch_id: selectedDealer,
                message: message,
                comment: message,
                utm_source: utm_source,
                utm_medium: utm_medium,
                utm_campaign: utm_campaign,
                gad_source: gad_source,
                gclid: gclid,
                agree_regulations1: agreeVal1,
                agree_regulations2: agreeVal2,
                agree_regulations3: agreeVal3,
                agree_regulations4: agreeVal4,
                book_type: "test_drive_form"
            });

            $.ajax({
                type: 'POST',
                url: '/jazdaprobna',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    model_id: selectedModel,
                    branch_id: selectedDealer,
                    message: message,
                    comment: message,
                    utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,
                    gad_source: gad_source,
                    gclid: gclid,
                    contact_channel_email: (agreeVal1 ? 1 : 0),
                    contact_channel_sms: (agreeVal2 ? 1 : 0),
                    contact_channel_phone: (agreeVal3 ? 1 : 0),
                    i_consent_to_the_processing_of_my_data: (agreeVal4 ? 1 : 0),
                    book_type: "test_drive_form",
                    type: "test_drive_form"
                },
                success: function (result) {

                    console.log(result.success);
                    $('#testdrive_contact .btn-form').removeAttr("disabled");

                    if (result.success) {
                        $('#formSuccess').modal('show')
                        $("#testdrive_modal").trigger("reset");
                        $('#testdriveFirstname').val('');
                        $('#testdriveLastname').val('');
                        $('#testdriveEmail').val('');
                        $('#testdrivePhone').val('');
                        $('#input_model').val('');
                        $('#input_dealer').val('');
                        $('#testdriveAgreeEmail').prop('checked', false);
                        $('#testdriveAgreePhone').prop('checked', false);
                        $('#testdriveAgreeRegulations1').prop('checked', false);
                        $('#testdriveAgreeRegulations2').prop('checked', false);

                        $('#testdrive_modal').modal('hide');

                        // $('#exampleModalCenter2').modal({
                        //     keyboard: false,
                        //     backdrop: 'static',
                        // });
                        // $('#exampleModalCenter2').modal('show')
                        // $("#formContact_main").trigger("reset");

                        if (window.location.href.includes('bmg.sopot')){
                            var axel = Math.random() + "";
                            var a = axel * 10000000000000;
                            $('body').prepend('<iframe src="https://11627135.fls.doubleclick.net/activityi;src=11627135;type=baics0;cat=baic_003;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
                        }
                    } else {
                        alert('Zapis nie powiódł się. Spróbuj ponownie');
                    }
                }
            });
        }
    });

    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhone(txtPhone) {
        var regex = /^[0-9]+$/
        return regex.test(txtPhone);
    }


    $(".form-select").change(function () {
        if ($(this).val() !== " ") {
            $('.select_title').addClass('active');
        } else {
            // Pole nie jest zaznaczone
            $('.select_title').removeClass('active');
        }
    });

    let province = 'Wybierz województwo';
    let interval = setInterval(updateDealers, 200);
    let chooseManual = false;

    function updateDealers() {
        let input = $("#select2-inputProvince-container");
        if (input.length > 0) {
            if (false) {
            //if (mobileCheck() && !chooseManual) {
                clearInterval(interval);
                navigator.geolocation.getCurrentPosition(getLocation, () => null);
            } else {
                if (province !== input.attr('title')) {
                    province = input.attr('title');
                    $.ajax({
                        _token: $('#token').val(),
                        url: '/filter_dealers',
                        type: 'GET',
                        data: {province: province},
                    }).then(function (dealers) {
                        let dealerInput = $("#inputDealer");
                        dealerInput.find('option').remove();
                        dealerInput.append(`<option value="" selected disabled>Wybierz dealera</option>`)
                        for (const dealer of dealers)
                            dealerInput.append(`<option value="${dealer.value}">${dealer.city} ${dealer.name}</option>`);
                    })
                }
            }
        }
    }

    function mobileCheck() {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v\|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substring(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    function getLocation(position) {
        let location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
        $.ajax({
            _token: $('#token').val(),
            url: '/get_dealers',
            type: 'GET',
        }).then(function (dealers) {
            let nearest = findNearestDealer(location, dealers);
            $(".inputProvinceWrapper").css('display', 'none');
            let dealerInput = $("#inputDealer");
            dealerInput.find('option').remove();
            dealerInput.append(`<option value="${nearest.department_autobahn_company_id}" selected>${nearest.department_city} ${nearest.department_name} (wg lokalizacji)</option>`);

            $(".inputProvinceWrapper").css('display', 'none');
            let dealerInput2 = $("#inputDealerTestDrive");
            dealerInput2.find('option').remove();
            dealerInput2.append(`<option value="${nearest.department_autobahn_company_id}" selected>${nearest.department_city} ${nearest.department_name} (wg lokalizacji)</option>`);
        })
    }

    function findNearestDealer(searchLocation, dealerMarkersArray) {
        if (!searchLocation || !dealerMarkersArray || dealerMarkersArray.length === 0) {
            return null;
        }

        function haversine(lat1, lon1, lat2, lon2) {
            const R = 6371;
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; //distance
        }

        let nearestDealer = null;
        let minDistance = Number.MAX_VALUE;

        dealerMarkersArray.forEach(dealer => {
            const distance = haversine(
                searchLocation.lat,
                searchLocation.lng,
                dealer.department_latitude,
                dealer.department_longitude
            );
            if (distance < minDistance) {
                minDistance = distance;
                nearestDealer = dealer;
            }
        });
        return nearestDealer;
    }

    function getCookie(cookieName) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    }
});
